import { runInAction } from 'mobx';
import { getCacheDuration } from '../../../../utils/get-cache-duration';
import { orderDomainStore } from '../../store';
import { assignOrderRelatedData } from '../../utils/assign-order-related-data';
/**
 * Syncs the order with updated data from the API.
 *
 * @remarks
 * Any selections should be cleared as necessary by the relevant action.
 */
export const syncOrder = (orderDetails) => {
    runInAction(() => {
        orderDomainStore.data.order = orderDetails.order;
        assignOrderRelatedData(orderDetails.relatedData, getCacheDuration('orders'));
    });
};
